// extracted by mini-css-extract-plugin
export default {"paymentList":"AxVIk","icon":"JeA9E"};